export class SpecStore {
    constructor(std) {
        this.std = std;
        this._specs = new Map();
        this._services = new Map();
    }
    dispose() {
        this._services.forEach(service => {
            service.dispose();
            service.unmounted();
        });
        this._services.clear();
    }
    applySpecs(specs) {
        const oldSpecs = this._specs;
        const newSpecs = this._buildSpecMap(specs);
        this._diffServices(oldSpecs, newSpecs);
        this._specs = newSpecs;
    }
    getView(flavour) {
        const spec = this._specs.get(flavour);
        if (!spec) {
            return null;
        }
        return spec.view;
    }
    getService(flavour) {
        return this._services.get(flavour);
    }
    _diffServices(oldSpecs, newSpecs) {
        oldSpecs.forEach((oldSpec, flavour) => {
            if (newSpecs.has(flavour) &&
                newSpecs.get(flavour)?.service === oldSpec.service) {
                return;
            }
            const service = this._services.get(flavour);
            if (service) {
                service.dispose();
                service.unmounted();
            }
            this._services.delete(flavour);
        });
        newSpecs.forEach((newSpec, flavour) => {
            if (this._services.has(flavour)) {
                return;
            }
            if (!newSpec.service) {
                return;
            }
            const service = new newSpec.service({
                flavour,
                std: this.std,
            });
            this._services.set(flavour, service);
            service.mounted();
        });
    }
    _buildSpecMap(specs) {
        const specMap = new Map();
        specs.forEach(spec => {
            specMap.set(spec.schema.model.flavour, spec);
        });
        return specMap;
    }
}
//# sourceMappingURL=spec-store.js.map